// extracted by mini-css-extract-plugin
export default {"input-wrapper":"AutoComplete_input-wrapper__nBwXM","icon":"AutoComplete_icon__429Kr","input":"AutoComplete_input__YRu20"};